import { Radio as AriaKitRadio } from "ariakit";
import styled from "styled-components";
import { style } from "../style";
import { hexWithOpacityToRBGA } from "../utils/hexWithOpacityToRBGA";

export const LooseRadioInput = styled(AriaKitRadio)`
  all: unset;

  appearance: none;

  box-sizing: border-box;

  width: 100%;
  height: 100%;
  display: block;

  border-radius: 50%;
  border-style: solid;

  border-width: ${style.vars.borderWidth.thin};
  border-color: ${style.colors.grey.primary};

  &:checked {
    border-color: ${style.colors.blue.dark};
    border-width: 4px;
  }

  &:disabled {
    border-color: ${hexWithOpacityToRBGA(style.colors.grey.primary, 0.3)};
    border-width: ${style.vars.borderWidth.thin};
  }

  box-shadow: none;

  :hover:not(:disabled) {
    box-shadow: 0 0 0 2px ${style.colors.blue.primary};
  }
`;

LooseRadioInput.displayName = "LooseRadioInput";
